<template>
    <div id="header" class="header">
        <div class="header-top">
            <div class="wrapper clearfix">
                <div class="col-sm-23 no-padding" >
                    <div class="city"><a href="#" @click="modalS">{{city.name}} ▼</a></div>
                    <div class="modal" :style="[ modalShow ? {display: 'block'} : {display: 'none'}]" >
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <a type="button" class="close" @click="modalS">
                                        <span aria-hidden="true">×</span>
                                    </a>
                                    <h4 id="is-city" style="display: none; text-align: center;">Вы из города <span id="is-city-name"></span>? <button id="is-city-button" type="button" class="btn btn-primary" data-dismiss="modal">Да</button></h4>
                                    <h4>Выберите город</h4>
                                </div>
                                <div class="modal-body clearfix">
                                    <div class="row">
                                        <div class="col-md-120 clearfix">
                                            <select name="city" class="select2 geo-search" id="geo-search"></select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 no-padding">
                </div>
                <div class="col-sm-20 no-padding">
                    <div class="phone">
                        <a href="#">{{city.phone}}</a>
                    </div>
                </div>
                <div class="col-sm-40 no-padding">
                    <div class="lang" style="display:none">
                        <div class="btn-group dropdown">
                            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" style="text-transform: uppercase;">
                                <span class="lang-sm lang-lbl">((lang))</span> <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu" role="menu">
                                {% for l in langs %}
                                <li><router-link to="#" class="multilanguage-set" data-language="1"><span class="lang-sm lang-lbl">((l.title))</span></router-link></li>
                                {% endfor %}
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-20 city" style="color:#fff;float: right;">
                    <router-link to="/cabinet/logout/" v-if="auth.id">Выход</router-link>
                    <router-link to="/cabinet/login/" v-if="!auth.id">Вход</router-link>
                    |
                    <router-link to="/cabinet/" v-if="auth.id">Кабинет</router-link>
                    <router-link to="/cabinet/registration/" v-if="!auth.id">Получи {{city.bonus}} {{city.valute}}</router-link>
                </div>
            </div>
        </div>
        <div class="header-bottom">
            <div class="wrapper clearfix">
                <div class="col-md-39 col-sm-70 no-padding">
                    <div class="logo">
                        <router-link to="/" v-if="city.lang == 'md'"><img src="/static/img/general/logo-lat.png"></router-link>
                        <router-link to="/" v-if="city.lang != 'md'"><img src="/static/img/general/logo.png"></router-link>
                        <p class="text_in_logo" style="display: block; text-align: center; font-family: 'Times New Roman', Times, serif; font-size: 12pt;">
                            все сервисы города на одном сайте
                        </p>
                    </div>
                </div>
                <div class="col-md-30 col-sm-30">
                    <div class="trust">
                        <router-link to="/pochemu-remont-doveryayut-nam/">Почему ремонт доверяют нам?</router-link>
                    </div>
                </div>
                <div class="col-md-20">
                    <div class="calculation">
                        <router-link to="/cabinet/messages" class="messages get-price" style="">
                            <div style="display: inline;position: relative;width: 33px;height: 33px;">
                                <img src="/static/img/icon-message-blue.svg">
                                <div v-if="countMessages > 0" class="amount -active"  style="top: -10px;">{{countMessages}}</div>
                            </div> Мои Заявки
                        </router-link>
                    </div>
                </div>
                <div class="col-md-31">
                    <router-link to="/cabinet/messages" style="display: none" :class="[leads.length > 0 ?  'messages -active' : 'messages']">
                        <div v-if="countMessages > 0" class="amount -active">и{{countMessages}}</div>
                    </router-link>
                    <div class="calculation">
                        <router-link to="#want-price" class="get-price">Расчет стоимости ремонта</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
export default {
  name: 'header-block',
  props: ['city', 'user', 'auth', 'leads'],
  data () {
    return {
      modalShow: false,
      countMessages: 0
    }
  },
  methods: {
    modalS: function () {
      if (this.modalShow) this.modalShow = false
      else {
        this.modalShow = true
      }
    },
    hideCity () {
      this.modalShow = false
    }
  },
  watch: {
    leads: function (val) {
      this.countMessages = 0
      if (this.auth.role === 1) {
        for (var id in val) if (val[id].status === 0) this.countMessages++
      } else {
        for (var ids in val) if (val[ids].status === 1) this.countMessages++
      }
    }
  },
  mounted () {
    var $this = this
    $('#geo-search').select2({
      placeholder: 'Выберите город',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-cities',
        dataType: 'json',
        data: function (params) {
          params.lang = $this.city.lang
          params.q = params.term
          return params
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              return {
                text: item.text,
                id: item.id
              }
            })
          }
        }
      }
    }).on('change.select2', function (data) {
      axios.get('https://crm.v-avtoservice.com/list/site-get-city?id=' + $(this).val() + '&uid=' + $this.user.uid).then(response => {
        let OldData = $this.$root.city.id
        $this.city = response.data
        $this.$cookie.set('city', JSON.stringify(response.data), {expires: '1Y', domain: window.location.hostname})
        $this.modalShow = false
        if (OldData !== response.data.id) location.reload()
      })
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header.vue